var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-text-editor',{attrs:{"textKey":"pvp_rules","title":"PvP Rules","viewPermission":"PvpRulesView","editPermission":"PvpRulesEdit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }